import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../apiServices/axios';
import { IRL_ITEMS, AZ_SEARCH, DATAROOM_WORKSTREAM, DEFAULT_WORKSTREAMS, DEFAULT_FOLDERS, IRL_DOC } from '../apiServices/api_routes';
import { toast } from 'react-toastify';

export const GetDataroomItemInfo = createAsyncThunk('GET_IRL_ITEMS', async id => {
    const data = await axiosInstance.get(IRL_ITEMS + localStorage['project_id'] + '/' + id + '/');
    return data;
});
export const PatchWSFolder = createAsyncThunk('PATCH_IRL_ITEMS', async body => {
    const data = await axiosInstance.patch(IRL_ITEMS + localStorage['project_id'] + '/' + body?.workstream + '/' + body?.id + '/', body);
    return data;
});
export const PostWSFolder = createAsyncThunk('POST_IRL_ITEMS', async (body, { rejectWithValue }) => {
    try {
        const data = await axiosInstance.post(IRL_ITEMS + localStorage['project_id'] + '/' + body?.workstream + '/', body);
        return data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const PostAllWSFolders = createAsyncThunk('POST_WS_FODLERS_ALL', async workstream => {
    const data = await axiosInstance.post(IRL_ITEMS + localStorage['project_id'] + '/' + workstream + '/request_all/');
    return data;
});

export const DeleteWSFolder = createAsyncThunk('DELETE_IRL_ITEMS', async (body, { rejectWithValue }) => {
    try {
        const data = await axiosInstance.delete(IRL_ITEMS + localStorage['project_id'] + '/' + body?.workstream + '/' + body.id + '/');
        return data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const GetFilesSearch = createAsyncThunk('GET/GetFilesSearch', async ({ query }) => {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('api-key', process.env.REACT_APP_AZURE_SEARCH_KEY);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
    };
    const data = await fetch(`https://${AZ_SEARCH}.search.windows.net/indexes/azureblob-index/docs?search=${localStorage['project_id']}${query}`, requestOptions);
    const res = await data.json();
    return res;
});
export const GetSearchByPost = createAsyncThunk('POST/GetSearchByPost', async ({ workstream, formData, searchText }, { rejectWithValue }) => {
    try {
        const data = await axiosInstance.post(IRL_DOC + localStorage['project_id'] + '/' + workstream + '/search/?search_term=' + searchText, formData);
        return data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const GetWorkstreams = createAsyncThunk('GET_DATAROOM_WORKSTREAM', async (projectId, { rejectWithValue }) => {
    const pid = projectId || localStorage['project_id'];
    if (!pid) {
        return rejectWithValue('Project id is required to load workstreams.');
    }
    const data = await axiosInstance.get(DATAROOM_WORKSTREAM + pid + '/');
    return data;
});
export const GetWorkstreamsDefaults = createAsyncThunk('GET_DEFAULT_WORKSTREAMS', async () => {
    const data = await axiosInstance.get(DEFAULT_WORKSTREAMS);
    return data;
});
export const PostWorkstream = createAsyncThunk('POST_DATAROOM_WORKSTREAM', async (body, { rejectWithValue }) => {
    try {
        const data = await axiosInstance.post(DATAROOM_WORKSTREAM + localStorage['project_id'] + '/', body);
        return data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});
export const PatchWorkstream = createAsyncThunk('PATCH_DATAROOM_WORKSTREAM', async (body, { rejectWithValue }) => {
    try {
        const data = await axiosInstance.patch(DATAROOM_WORKSTREAM + localStorage['project_id'] + '/' + body?.id + '/', body);
        return data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});
export const DeleteWorkstream = createAsyncThunk('DELETE_DATAROOM_WORKSTREAM', async (idOrBody, { rejectWithValue }) => {
    const id = typeof idOrBody === 'object' ? idOrBody?.id : idOrBody;
    try {
        const data = await axiosInstance.delete(DATAROOM_WORKSTREAM + localStorage['project_id'] + '/' + id + '/');
        return data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});
export const GetFolderDefaults = createAsyncThunk('GET_DEFAULT_FOLDERS', async id => {
    const data = await axiosInstance.get(DEFAULT_FOLDERS + id + '/');
    return data;
});
export const BulkFileDownload = createAsyncThunk('POST_BULK_FOLDER_DOWNLOAD', async ({ id, body }) => {
    try {
        const response = await axiosInstance.post(`/dataroom/bulk_download/${localStorage['project_id']}/${id}/`, body, {
            responseType: 'blob', // Handle the response as a Blob
            maxBodyLength: Infinity,
        });

        return response;
    } catch (error) {
        console.error('Bulk File Download Error:', error);
        throw error; // Rethrow the error for further handling
    }
});

export const GetAIDocumentAnalysis = createAsyncThunk('GET_AI_DOCUMENT_ANALYSIS', async ({ projectId, wsId, documentId, documentUrl, regenerate = false, quickSnapshot = false }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/dataroom/documents_IRL/${projectId}/${wsId}/${documentId}/ai_analysis/`, {
            document_url: documentUrl,
            regenerate: regenerate, // Pass regenerate flag to backend
            quick_snapshot: quickSnapshot,
        });
        return response.data;
    } catch (error) {
        console.error('AI Document Analysis Error:', error);
        return rejectWithValue(error.response?.data?.error || error.message || 'Failed to analyze document');
    }
});

export const GetLatestDocumentAnalysis = createAsyncThunk('GET_LATEST_DOCUMENT_ANALYSIS', async ({ projectId, wsId, documentId, quickSnapshot = false }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(
            `/dataroom/documents_IRL/${projectId}/${wsId}/${documentId}/get_latest_analysis/`,
            { params: quickSnapshot ? { quick_snapshot: true } : {} },
        );
        return response.data;
    } catch (error) {
        console.error('Get Latest Analysis Error:', error);

        // If it's a 404 with "No analysis found", treat it as a special case
        if (error.response?.status === 404 && error.response?.data?.message === 'No analysis found for this document') {
            return {
                has_analysis: false,
                message: 'No analysis found for this document',
                document_id: documentId,
                should_generate: true, // Special flag to trigger generation
            };
        }

        // For other errors, reject normally
        return rejectWithValue(error.response?.data?.error || error.message || 'Failed to get latest analysis');
    }
});

/** POST project-scoped RAG chat (Azure Search + optional synthesis). Body: question, top, file_ids (optional). */
export const PostRagChat = createAsyncThunk('dataroom/postRagChat', async ({ projectId, wsId, body }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`${IRL_DOC}${projectId}/${wsId}/rag_chat/`, body);
        return response.data;
    } catch (error) {
        const d = error.response?.data;
        return rejectWithValue(typeof d === 'object' ? d : { detail: error.message || 'RAG request failed' });
    }
});

export const irlSlice = createSlice({
    name: 'irlSlice',
    initialState: {
        items: [],
        accepted: 0,
        requested: 0,
        status: null,
        data: [],
        files: [],
        searchedFiles: [],
        workstreams: [],
        addWsLoading: false,
        default_workstreams: [],
        default_folders: [],
        folderBtnLoading: false,
        addAllFolderLoading: false,
        bulkFilesLoading: false,
        joyRideStepIndex: 0,
        aiAnalysisData: null,
        aiAnalysisLoading: false,
        aiAnalysisError: null,
    },
    reducers: {
        setIRLItems: (state, { payload }) => {
            return { ...state, items: payload };
        },
        removeDataroomData: (state, { payload }) => {
            return { ...state, default_folders: [], default_workstreams: [], workstreams: [], data: [], files: [], items: [] };
        },
        setIRLItemsRecieved: (state, { payload }) => {
            let newArr = state.items.map(item => {
                if (item.id === payload?.id) {
                    return { ...item, received: payload?.flag };
                } else {
                    return item;
                }
            });
            return { ...state, items: newArr };
        },
        setJoyRideStepIndex: (state, { payload }) => {
            return { ...state, joyRideStepIndex: payload };
        },
        resetDataroomData: (state, { payload }) => {
            return {
                items: [],
                accepted: 0,
                requested: 0,
                status: null,
                data: [],
                files: [],
                searchedFiles: [],
                workstreams: [],
                addWsLoading: false,
                default_workstreams: [],
                default_folders: [],
                folderBtnLoading: false,
                addAllFolderLoading: false,
                bulkFilesLoading: false,
                joyRideStepIndex: 0,
                folderDataLoading: false,
                searchBtnLoading: false,
            };
        },
    },
    extraReducers: {
        //GetDataroomItemInfo
        [GetDataroomItemInfo.pending]: (state, action) => {
            state.status = 'loading';
            state.items = [];
            state.folderDataLoading = true;
        },
        [GetDataroomItemInfo.fulfilled]: (state, action) => {
            state.status = 'success';
            // state.items = action.payload?.data;
            state.folderDataLoading = false;
            state.items = action.payload?.data?.sort((a, b) => (a?.prefix > b?.prefix ? 1 : b?.prefix > a?.prefix ? -1 : 0));
        },
        [GetDataroomItemInfo.rejected]: (state, action) => {
            state.status = 'rejected';
            state.folderDataLoading = false;
        },
        //PatchWSFolder
        [PatchWSFolder.pending]: (state, action) => {
            state.status = 'loading';
            state.folderBtnLoading = true;
        },
        [PatchWSFolder.fulfilled]: (state, { payload }) => {
            state.status = 'success';
            state.items = state.items.map(item => {
                if (item?.id === payload.data?.id) {
                    return payload.data;
                } else return item;
            });
            state.folderBtnLoading = false;
            toast.success('Success');
        },
        [PatchWSFolder.rejected]: (state, action) => {
            state.status = 'rejected';
            state.folderBtnLoading = false;
            toast.error('Failed');
        },
        //PostWSFolder
        [PostWSFolder.pending]: (state, action) => {
            state.status = 'loading';
            state.folderBtnLoading = true;
        },
        [PostWSFolder.fulfilled]: (state, { meta, payload }) => {
            console.log({ meta, payload });
            state.status = 'success';
            const created = payload?.data;
            const createdWs = created?.workstream ?? created?.ws_id;
            const listedWs = state.items?.[0]?.workstream ?? state.items?.[0]?.ws_id;
            const belongsOnCurrentList = !listedWs || String(listedWs) === String(createdWs);
            if (created && belongsOnCurrentList && !state.items.some(item => item.id === created.id)) {
                state.items.push(created);
            }
            state.folderBtnLoading = false;
            if (payload?.data?.parent) {
                function updateFolderStructure(folderArray, parentId, newData) {
                    folderArray?.forEach(item => {
                        if (item?.id === parentId) {
                            item.children = [...item?.children, newData];
                        }
                        if (item?.children?.length > 0) {
                            updateFolderStructure(item?.children, parentId, newData);
                        }
                    });
                }
                updateFolderStructure(state?.items, payload?.data?.parent, payload?.data);
            }
        },
        [PostWSFolder.rejected]: (state, action) => {
            const payload = action?.payload;
            const fieldError =
                payload && typeof payload === 'object'
                    ? Object.values(payload)
                          .flat()
                          .find(item => typeof item === 'string')
                    : null;
            if (
                payload?.non_field_errors &&
                payload.non_field_errors.some(error => error.includes('The fields workstream, name must make a unique set'))
            ) {
                toast.error('Folder not added - a folder with this name already exists in the workstream.');
            } else {
                toast.error(payload?.detail || fieldError || 'Failed to create folder');
            }
            state.status = 'rejected';
            state.folderBtnLoading = false;
        },
        //DeleteWSFolder
        [DeleteWSFolder.pending]: (state, action) => {
            state.status = 'loading';
        },
        [DeleteWSFolder.fulfilled]: (state, action) => {
            state.status = 'success';
            // state.items.push(payload.data);
            let data = [...state?.items];
            function removeFolderRecursively(folderArray, folderIdToRemove) {
                // Iterate through each folder in the array
                for (let i = 0; i < folderArray.length; i++) {
                    const folder = folderArray[i];

                    // If the current folder's ID matches the folderIdToRemove, remove it
                    if (folder.id === folderIdToRemove) {
                        folderArray.splice(i, 1);
                        i--; // Decrement i to adjust for the removed element
                    } else {
                        // Recursively search and remove the folder from children arrays
                        removeFolderRecursively(folder.children, folderIdToRemove);
                    }
                }
            }
            removeFolderRecursively(data, action?.meta?.arg?.id);
            state.items = data;
            // state.items = state.items?.filter(item => action?.meta?.arg?.id !== item?.id);
            toast.success('Success');
        },
        [DeleteWSFolder.rejected]: (state, action) => {
            console.log(action);
            toast.error(action?.payload?.detail);
            state.status = 'rejected';
        },

        //GetFilesSearch

        [GetFilesSearch.fulfilled]: (state, action) => {
            state.status = 'success';
            state.files = action.payload.value;
            // state.files = action.payload.value?.sort((objA, objB) => Number(new Date(objA?.metadata_creation_date)) - Number(new Date(objB?.metadata_creation_date)));
        },
        //GetSearchByPost
        [GetSearchByPost.pending]: (state, action) => {
            state.searchBtnLoading = true;
        },
        [GetSearchByPost.fulfilled]: (state, action) => {
            state.status = 'success';
            state.searchBtnLoading = false;
            console.log(action);
            state.searchedFiles = action.payload.data?.sort((objA, objB) => Number(new Date(objA?.metadata_creation_date)) - Number(new Date(objB?.metadata_creation_date)));
        },
        [GetSearchByPost.rejected]: (state, action) => {
            state.searchBtnLoading = false;
        },
        //GetWorkstreams
        [GetWorkstreams.pending]: (state, action) => {
            state.status = 'loading';
        },
        [GetWorkstreams.fulfilled]: (state, { payload }) => {
            state.workstreams = payload?.data;
            state.status = 'success';
        },
        [GetWorkstreams.rejected]: (state, action) => {
            state.status = 'rejected';
        },

        //PostWorkstream
        [PostWorkstream.pending]: (state, action) => {
            state.status = 'loading';
            state.addWsLoading = true;
        },
        [PostWorkstream.fulfilled]: (state, { payload, meta }) => {
            // state.workstreams = payload?.data;
            state.status = 'success';
            state.workstreams.push(payload?.data);
            state.addWsLoading = false;
            if (!meta?.arg?.suppressSuccessToast) {
                toast.success('Workstream created successfully');
            }
        },
        [PostWorkstream.rejected]: (state, action) => {
            state.status = 'rejected';
            state.addWsLoading = false;

            // Get the error message from the payload (which contains the backend response)
            const errorMessage = action.payload?.detail || action.error?.message || 'Failed to create workstream';

            // Display the actual error message from the backend
            toast.error(errorMessage);
        },
        //PatchWorkstream
        [PatchWorkstream.pending]: (state, action) => {
            state.status = 'loading';
            state.addWsLoading = true;
        },
        [PatchWorkstream.fulfilled]: (state, { payload, meta }) => {
            state.status = 'success';
            state.workstreams = state.workstreams?.map(item => {
                if (item?.id === payload?.data?.id) return payload?.data;
                else return item;
            });
            state.addWsLoading = false;
            if (!meta?.arg?.suppressSuccessToast) {
                toast.success('Workstream updated successfully');
            }
        },
        [PatchWorkstream.rejected]: (state, action) => {
            state.status = 'rejected';
            state.addWsLoading = false;

            // Get the error message from the payload (which contains the backend response)
            const errorMessage = action.payload?.detail || action.error?.message || 'Failed to update workstream';

            // Display the actual error message from the backend
            toast.error(errorMessage);
        },
        //DeleteWorkstream
        [DeleteWorkstream.pending]: (state, action) => {
            state.status = 'loading';
        },
        [DeleteWorkstream.fulfilled]: (state, { meta }) => {
            state.status = 'success';
            const deletedId = typeof meta?.arg === 'object' ? meta.arg?.id : meta?.arg;
            state.workstreams = state.workstreams?.filter(item => item?.id !== deletedId);
            if (!meta?.arg?.suppressSuccessToast) {
                toast.success('Workstream deleted successfully');
            }
        },
        [DeleteWorkstream.rejected]: (state, action) => {
            state.status = 'rejected';

            // Get the error message from the payload (which contains the backend response)
            const errorMessage = action.payload?.detail || action.error?.message || 'Failed to delete workstream';

            // Display the actual error message from the backend
            toast.error(errorMessage);
        },
        //GetWorkstreamsDefaults
        [GetWorkstreamsDefaults.pending]: (state, action) => {
            state.status = 'loading';
        },
        [GetWorkstreamsDefaults.fulfilled]: (state, { payload }) => {
            state.default_workstreams = payload.data;
            state.status = 'success';
        },
        [GetWorkstreamsDefaults.rejected]: (state, action) => {
            state.status = 'rejected';
        },

        //GetFolderDefaults
        [GetFolderDefaults.pending]: (state, action) => {
            state.status = 'loading';
        },
        [GetFolderDefaults.fulfilled]: (state, { payload }) => {
            state.status = 'success';
            state.default_folders = payload.data;
        },
        [GetFolderDefaults.rejected]: (state, action) => {
            state.status = 'rejected';
        },
        //PostAllWSFolders
        [PostAllWSFolders.pending]: (state, action) => {
            state.status = 'loading';
            state.addAllFolderLoading = true;
        },
        [PostAllWSFolders.fulfilled]: (state, { payload }) => {
            state.status = 'success';
            state.items = payload.data;
            state.addAllFolderLoading = false;
            toast.success('Folders added successfully!');
            // console.log(payload);
        },
        [PostAllWSFolders.rejected]: (state, action) => {
            state.status = 'rejected';
            state.addAllFolderLoading = false;
            toast.error('Failed to add folders. Please try again.');
        },
        //BulkFileDownload
        [BulkFileDownload.fulfilled]: (state, { payload }) => {
            // const url = window.URL.createObjectURL(new Blob([payload?.data], { type: 'application/zip' }));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', 'fileName.zip');
            // document.body.appendChild(link);
            // link.click();
            // link.parentNode.removeChild(link);
            // state.status = 'rejected';
            // state.addAllFolderLoading = false;
        },

        //GetAIDocumentAnalysis
        [GetAIDocumentAnalysis.pending]: (state, action) => {
            state.aiAnalysisLoading = true;
            state.aiAnalysisError = null;
        },
        [GetAIDocumentAnalysis.fulfilled]: (state, { payload }) => {
            state.aiAnalysisLoading = false;
            state.aiAnalysisData = payload;
            state.aiAnalysisError = null;
        },
        [GetAIDocumentAnalysis.rejected]: (state, { payload }) => {
            state.aiAnalysisLoading = false;
            state.aiAnalysisError = payload;
            state.aiAnalysisData = null;
        },
        //GetLatestDocumentAnalysis
        [GetLatestDocumentAnalysis.pending]: (state, action) => {
            state.aiAnalysisLoading = true;
            state.aiAnalysisError = null;
        },
        [GetLatestDocumentAnalysis.fulfilled]: (state, { payload }) => {
            state.aiAnalysisLoading = false;
            state.aiAnalysisData = payload;
            state.aiAnalysisError = null;
        },
        [GetLatestDocumentAnalysis.rejected]: (state, { payload }) => {
            state.aiAnalysisLoading = false;
            state.aiAnalysisError = payload;
            state.aiAnalysisData = null;
        },
    },
});
export const { setIRLItems, setIRLItemsRecieved, removeDataroomData, setJoyRideStepIndex, resetDataroomData } = irlSlice.actions;
export default irlSlice.reducer;
